var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFamilyCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 144,
    viewBox: "0 0 208 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 128,
    r: 16,
    transform: "rotate(-90 148 128)",
    fill: "#07C8F9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 128,
    r: 16,
    transform: "rotate(-90 104 128)",
    fill: "#07C8F9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 128,
    r: 16,
    transform: "rotate(-90 60 128)",
    fill: "#07C8F9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 128,
    r: 16,
    transform: "rotate(-90 16 128)",
    fill: "#07C8F9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 128,
    r: 16,
    transform: "rotate(-90 192 128)",
    fill: "#07C8F9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 72,
    r: 16,
    transform: "rotate(-90 148 72)",
    fill: "#07C8F9"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 72,
    r: 16,
    transform: "rotate(-90 60 72)",
    fill: "#07C8F9"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 72,
    r: 16,
    transform: "rotate(-90 16 72)",
    fill: "#07C8F9"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 72,
    r: 16,
    transform: "rotate(-90 192 72)",
    fill: "#07C8F9"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 16,
    r: 16,
    transform: "rotate(-90 104 16)",
    fill: "#07C8F9"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 72,
    r: 16,
    transform: "rotate(-90 104 72)",
    fill: "#07C8F9"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    transform: "rotate(-90 16 16)",
    fill: "#07C8F9"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 16,
    r: 16,
    transform: "rotate(-90 148 16)",
    fill: "#07C8F9"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 16,
    r: 16,
    transform: "rotate(-90 192 16)",
    fill: "#07C8F9"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 16,
    r: 16,
    transform: "rotate(-90 60 16)",
    fill: "#07C8F9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyCircle);
export default __webpack_public_path__ + "static/media/familyCircle.63bf7b83c25e5f5483fd597f4e892b97.svg";
export { ForwardRef as ReactComponent };